import { Component, input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { Auction } from '../../models/auction';
import { AuctionBid } from '../../models/auctionBid';

@Component({ standalone: false,
  selector: 'app-bidding-history-public',
  templateUrl: 'bidding-history-public.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['bidding-history-public.component.scss']
})
export class BiddingHistoryPublicComponent {
  @ViewChild('biddingHistoryTable') biddingHistoryTable?: MatTable<any>;

  readonly auction = input<Auction|undefined>(undefined);
  /** alternatively to auction: the bids and auction type directly (e.g. one auction sequence of the anonymized property history) */
  readonly bids = input<AuctionBid[]|undefined>(undefined);
  readonly auctionType = input<number|undefined>(undefined);
  public title: string= "Bidding History";
  public confirmButtonText = "OK";

  constructor() {
  }

  public update(){
    if(this.biddingHistoryTable) this.biddingHistoryTable.renderRows();
  }

  get tableBids(){
    return this.bids() ?? this.auction()?.bids;
  }

  get tableAuctionType(){
    return this.auctionType() ?? this.auction()?.auctionType;
  }

  get displayedColumns(): string[] {
    if(this.tableAuctionType==1)
      return ['bidder', 'status', 'amount', 'time', 'autobid' ];
    else
      return ['bidder', 'status', 'amount', 'time' ];
  } 
}